// extracted by mini-css-extract-plugin
module.exports = {"highcharts":"antheRsCard_highcharts__3PPFU","card115":"antheRsCard_card115__2Quki","highcharts-point":"antheRsCard_highcharts-point__EKVl3"};